/* eslint-disable camelcase */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Modal from 'reboron/DropModal'
import truncateMiddle from 'truncate-middle'
import SimpleMDE from 'react-simplemde-editor'

import ContentWarningsEditor from '../quest/ContentWarningsEditor'
import S3Uploader from './S3Uploader'
import YoutubeTrimmer from './YoutubeTrimmer'

import { fetchActivityResource } from './API'
import {
  isMissingFileData,
  isMissingLinkData,
  isValidLink,
  isMissingContentWarnings
} from '../../utils/activityedit'
import {
  save,
  cancel,
  credibleResource,
  helpCenter,
  name,
  fieldRequired,
  resourceDescriptionMessage,
  resourceTypeMessage,
  formatMessage,
  link,
  fileMessage,
  urlMessage,
  urlInvalid,
  resourceFile,
  attribution,
  attributionInsideOrg,
  attributionOutsideOrg,
  copyrightHolder,
  license,
  attributionAndNoncommercial,
  youreDone,
  provideCitation,
  remove
} from '../../utils/messages'
import { italicsOnlyMDEOptions } from '../../utils/markdowneditor'
import { isYoutubeLink } from '../../utils/resources'
import {
  getMinutesFromSeconds,
  getRemainingSecondsFromTotalTime
} from '../../utils/time'

// TODO: Really need to combine this and the AddResource Components, they are basically the same.
export default class EditResource extends Component {
  constructor(props) {
    super(props)
    this.state = {
      id: props.resourceId,
      resourceName: '',
      resourceDescription: '',
      resourceType: '',
      format: '',
      url: '',
      fileName: '',
      citation: '',
      attributionSelection: '',
      errorsExist: false,
      fileRemoved: false,
      hasContentWarnings: false,
      content_warnings: {},
      presignedUrl: {},
      isUploadingFile: false,
      startMinutes: null,
      startSeconds: null,
      endMinutes: null,
      endSeconds: null,
      fileToRemove: null,
      fileToPatch: null
    }

    this.handleChangeFormatToUrlBound = this.handleChangeFormatToUrl.bind(this)
    this.handleChangeFormatToFileBound =
      this.handleChangeFormatToFile.bind(this)
    this.onSaveResourceClickBound = this.onSaveResourceClick.bind(this)
    this.onCancelClickBound = this.onCancelClick.bind(this)
    this.onAttributionClickBound = this.onAttributionClick.bind(this)
    this.handleChangeBound = this.handleChange.bind(this)
    this.handleHideBound = this.handleHide.bind(this)
    this.onRemoveFileClickBound = this.onRemoveFileClick.bind(this)
    this.onToggleContentWarningsClickBound =
      this.onToggleContentWarningsClick.bind(this)
    this.onSetContentWarningClickBound =
      this.onSetContentWarningClick.bind(this)
    this.onResourceTypeChangeBound = this.onResourceTypeChange.bind(this)
    this.renderHasFileBound = this.renderHasFile.bind(this)
    this.setPatchFileUploadInfoBound = this.setPatchFileUploadInfo.bind(this)
    this.onUploadFileStartBound = this.onUploadFileStart.bind(this)
    this.onUploadFileEndBound = this.onUploadFileEnd.bind(this)
    this.onUploadAbortBound = this.onUploadAbort.bind(this)
    this.onUploadCompleteBound = this.onUploadComplete.bind(this)
    this.handleDescriptionChangeBound = this.handleDescriptionChange.bind(this)
    this.onSetYoutubeStartTimeMinutesBound =
      this.onSetYoutubeStartTimeMinutes.bind(this)
    this.onSetYoutubeStartTimeSecondsBound =
      this.onSetYoutubeStartTimeSeconds.bind(this)
    this.onSetYoutubeEndTimeMinutesBound =
      this.onSetYoutubeEndTimeMinutes.bind(this)
    this.onSetYoutubeEndTimeSecondsBound =
      this.onSetYoutubeEndTimeSeconds.bind(this)
    this.S3UploaderRef = React.createRef()
  }

  async componentDidMount() {
    const resource = await fetchActivityResource(
      this.props.organization.id,
      this.props.questId,
      this.props.activityId,
      this.props.resourceId,
      this.props.token
    )

    this.refs.modal.show()
    document.getElementsByTagName('html')[0].style.overflow = 'hidden'

    this.setState(() => ({
      id: resource.id,
      resourceName: resource.name,
      resourceDescription: resource.description,
      resourceType: resource.resource_type,
      format: resource.file_name ? 'file' : 'url',
      url: resource.url,
      fileName: resource.file_name,
      citation: resource.license_citation,
      attributionSelection: resource.license_id ? 'myorg' : 'outsideorg',
      hasContentWarnings: Object.keys(resource.content_warnings).length !== 0,
      content_warnings: resource.content_warnings,
      presignedUrl: resource.presigned_url,
      startMinutes: resource.start_time
        ? getMinutesFromSeconds(resource.start_time)
        : null,
      startSeconds: resource.start_time
        ? getRemainingSecondsFromTotalTime(resource.start_time)
        : null,
      endMinutes: resource.end_time
        ? getMinutesFromSeconds(resource.end_time)
        : null,
      endSeconds: resource.end_time
        ? getRemainingSecondsFromTotalTime(resource.end_time)
        : null,
      uniqueFilename: resource.unique_upload_file_name
    }))
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.uploadedResourceFile !== this.props.uploadedResourceFile) {
      this.setState(() => ({
        fileName: nextProps.uploadedResourceFile
      }))
    }
  }

  componentWillUnmount() {
    document.getElementsByTagName('html')[0].style.overflow = 'scroll'
  }

  render() {
    const modalStyle = {
      maxHeight: 'calc(100% - 100px)',
      position: 'fixed',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: '880px',
      background: '#fff',
      overflow: 'scroll',
      borderRadius: '6px'
    }

    var contentStyle = {
      backgroundColor: '#fff',
      height: '100%'
    }

    const {
      resourceName,
      resourceDescription,
      resourceType,
      format,
      url,
      fileName,
      errorsExist,
      fileRemoved,
      file,
      hasContentWarnings,
      content_warnings,
      attributionSelection
    } = this.state
    const { organization } = this.props

    const descriptionOptions = Object.assign({}, italicsOnlyMDEOptions)
    // descriptionOptions.initialValue = resourceDescription
    // descriptionOptions.placeholder = resourceDescription
    descriptionOptions.autofocus = false

    return (
      <Modal
        ref="modal"
        className="edit-activity-modal"
        modalStyle={modalStyle}
        contentStyle={contentStyle}
        onHide={this.handleHideBound}
        keyboard={false}
        closeOnClick={false}
      >
        <div className="modal-dialog" id="EditResourceModal">
          <form id="frmResource" onSubmit={e => e.preventDefault()}>
            <div className="qm-view">
              <h2>
                <span className="action"></span>
                Edit Resource
              </h2>
              <p>
                {credibleResource}
                &nbsp;
                <a
                  href="https://questforward.zendesk.com/hc/en-us/sections/115000870051-Resources-in-Quest-Design"
                  target="_blank"
                >
                  {helpCenter}
                </a>
                .
              </p>
              <div className="title">
                {name}
                <div className="requiredtool"></div>
              </div>
              <div className="edit-fields">
                <input
                  type="text"
                  name="resource_name"
                  id="resourceName"
                  className="form-control"
                  onChange={this.handleChangeBound}
                  defaultValue={resourceName}
                />
                {errorsExist && resourceName.length === 0 && (
                  <label className="error-text">{fieldRequired}</label>
                )}
              </div>

              <div className="title">{resourceDescriptionMessage}</div>
              <div className="edit-fields" id="resourceDescription">
                <SimpleMDE
                  value={resourceDescription}
                  options={descriptionOptions}
                  onChange={this.handleDescriptionChangeBound}
                />
              </div>

              <div className="title">{resourceTypeMessage}</div>
              <div className="edit-fields">
                <div className="url-selector">
                  <select
                    id="resourceType"
                    className="aDropdown"
                    onChange={this.onResourceTypeChangeBound}
                    value={resourceType}
                  >
                    <option value="audio">Audio</option>
                    <option value="document">Document</option>
                    <option value="game_app">App</option>
                    <option value="image">Image</option>
                    <option value="presentation">Presentation</option>
                    <option value="video">Video</option>
                    <option value="web">Web</option>
                    <option value="simulation">Simulation</option>
                  </select>
                </div>
              </div>

              <div className="title">{formatMessage}</div>
              <div className="edit-fields">
                <div className="url-selector">
                  <input
                    id="url_selector_url"
                    name="url_selector"
                    type="radio"
                    value="url"
                    checked={format === 'url'}
                    onChange={this.handleChangeFormatToUrlBound}
                  />
                  <label htmlFor="url_selector_url">{link}</label>
                  <input
                    id="url_selector_file"
                    name="url_selector"
                    type="radio"
                    value="file"
                    checked={format === 'file'}
                    onChange={this.handleChangeFormatToFileBound}
                  />
                  <label htmlFor="url_selector_file">{fileMessage}</label>
                </div>
              </div>

              {format === 'url' && (
                <React.Fragment>
                  <div className="form-group toggle-field url">
                    <div className="title">
                      {urlMessage}
                      <div className="requiredtool" />
                    </div>
                    <input
                      id="url"
                      name="url"
                      type="text"
                      className="form-control"
                      value={url}
                      onChange={this.handleChangeBound}
                    />
                    {errorsExist && !url && (
                      <label
                        id="resourceName-error"
                        className="error-text"
                        htmlFor="resourceName"
                        style={{ display: 'inline-block' }}
                      >
                        {fieldRequired}
                      </label>
                    )}
                    {errorsExist && !isValidLink(url) && url && url.length > 0 && (
                      <label
                        id="resourceName-error"
                        className="error-text"
                        htmlFor="resourceName"
                        style={{ display: 'inline-block' }}
                      >
                        {urlInvalid}
                      </label>
                    )}
                    {isYoutubeLink(url, resourceType) && (
                      <YoutubeTrimmer
                        setStartTimeMinutes={
                          this.onSetYoutubeStartTimeMinutesBound
                        }
                        setStartTimeSeconds={
                          this.onSetYoutubeStartTimeSecondsBound
                        }
                        setEndTimeMinutes={this.onSetYoutubeEndTimeMinutesBound}
                        setEndTimeSeconds={this.onSetYoutubeEndTimeSecondsBound}
                        startTimeMinutes={this.state.startMinutes}
                        startTimeSeconds={this.state.startSeconds}
                        endTimeMinutes={this.state.endMinutes}
                        endTimeSeconds={this.state.endSeconds}
                      />
                    )}
                  </div>
                  {url && url.length > 0 && (
                    <div className="form-group active" id="urlAttribution">
                      <div className="title">{attribution}</div>
                      <div className="attribution-selection">
                        <div className="selector">
                          <input
                            type="checkbox"
                            name="attributionSelection"
                            id="myorg"
                            onChange={this.onAttributionClickBound}
                            checked={attributionSelection === 'myorg'}
                          />
                          <label htmlFor="myorg">{attributionInsideOrg}</label>
                        </div>
                      </div>
                      {attributionSelection === 'myorg' && (
                        <div id="insideOrganization">
                          <hr />
                          <div className="wrap">
                            <strong>{copyrightHolder}</strong>:{' '}
                            {organization.name}
                          </div>
                          <div className="wrap">
                            <strong>{license}</strong>:&nbsp;
                            {attributionAndNoncommercial}
                          </div>
                          <div className="wrap">
                            <div className="check"></div>{' '}
                            <div className="done">{youreDone}</div>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </React.Fragment>
              )}
              {format === 'file' && (
                <div>
                  <div className="form-group toggle-field file">
                    <div className="title">
                      {resourceFile}
                      <div className="requiredtool" />
                    </div>
                    {(!fileName || this.state.isUploadingFile) && (
                      <div>
                        <S3Uploader
                          ref={this.S3UploaderRef}
                          presignedUrl={this.state.presignedUrl}
                          patchFileUploadInfo={this.setPatchFileUploadInfoBound}
                          resourceType={resourceType}
                          resourceId={this.state.id}
                          uploadStartHandler={this.onUploadFileStartBound}
                          uploadEndHandler={this.onUploadFileEndBound}
                          uploadAbortHandler={this.onUploadAbortBound}
                          uploadCompleteHandler={this.onUploadCompleteBound}
                          uniqueFilename={this.state.uniqueFilename}
                        />
                        {errorsExist && fileRemoved && !file && (
                          <label
                            id="file-error"
                            className="error-text"
                            htmlFor="file"
                          >
                            {fieldRequired}
                          </label>
                        )}
                      </div>
                    )}
                  </div>
                  {fileName ? this.renderHasFileBound() : ''}
                </div>
              )}

              <div className="title">Content Warnings</div>
              <p className="content-warnings-link">
                Let mentors know that this resource may contain objectionable
                content. &nbsp;
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://questforward.zendesk.com/hc/en-us/articles/115003486072-Understanding-OE-s-Quality-Review-Guideline#contentwarnings"
                >
                  Learn more
                </a>
              </p>
              <div className="edit-fields">
                <div className="content-warnings">
                  <input
                    id="content-warnings-true"
                    type="radio"
                    checked={hasContentWarnings === true}
                    value={true}
                    onClick={this.onToggleContentWarningsClickBound}
                  />
                  <label htmlFor="content-warnings-true">Yes</label>
                  <input
                    id="content-warnings-false"
                    type="radio"
                    checked={hasContentWarnings === false}
                    value={false}
                    onClick={this.onToggleContentWarningsClickBound}
                  />
                  <label htmlFor="content-warnings-false">No</label>
                </div>
              </div>
              {hasContentWarnings && (
                <ContentWarningsEditor
                  contentWarnings={content_warnings}
                  handleContentWarningClick={this.onSetContentWarningClickBound}
                />
              )}
              {errorsExist && isMissingContentWarnings(this.state) && (
                <label
                  id="content_warningsError"
                  className="error-text"
                  style={{ display: 'inline-block' }}
                >
                  Select one or more content warnings.
                </label>
              )}
              <div className="bottom">
                <div
                  className={`button save-resource btn-primary ${
                    this.state.isUploadingFile ? 'disable' : ''
                  }`}
                  onClick={this.onSaveResourceClickBound}
                >
                  {this.state.isUploadingFile ? 'Upload in Progress' : save}
                </div>
                <div
                  className="button cancel-add-resource btn-secondary"
                  onClick={this.onCancelClickBound}
                >
                  {cancel}
                </div>
                <div className="placeholder"></div>
              </div>
            </div>
          </form>
        </div>
      </Modal>
    )
  }

  renderHasFile() {
    const {
      resourceType,
      attributionSelection,
      fileName,
      errorsExist,
      citation
    } = this.state

    const { organization } = this.props

    return (
      <div>
        {fileName && (
          <div className="image-preview quest-image">
            <div className={`name ${resourceType}`}>
              {truncateMiddle(fileName, 40, 40, '...')}
            </div>
            <div
              className="button remove-file btn-destructive-small"
              onClick={this.onRemoveFileClickBound}
            >
              {remove}
            </div>
          </div>
        )}

        <div className="form-group active" id="attribution">
          <div className="title">{attribution}</div>
          <div className="requiredtool"></div>
          <div className="attribution-selection">
            <div className="selector">
              <input
                type="radio"
                name="attributionSelection"
                id="myorg"
                onChange={this.onAttributionClickBound}
                checked={attributionSelection === 'myorg'}
              />
              <label htmlFor="myorg">{attributionInsideOrg}</label>
            </div>
            <div className="selector">
              <input
                type="radio"
                name="attributionSelection"
                id="outsideorg"
                onChange={this.onAttributionClickBound}
                checked={attributionSelection === 'outsideorg'}
              />
              <label htmlFor="outsideorg">{attributionOutsideOrg}</label>
            </div>
            {errorsExist && !attributionSelection && (
              <label
                id="attributionSelection-error"
                className="error-text"
                htmlFor="attributionSelection"
              >
                {fieldRequired}
              </label>
            )}
            {attributionSelection === 'myorg' && (
              <div id="insideOrganization">
                <hr />
                <div className="wrap">
                  <strong>{copyrightHolder}</strong>: {organization.name}
                </div>
                <div className="wrap">
                  <strong>{license}</strong>:&nbsp;
                  {attributionAndNoncommercial}
                </div>
                <div className="wrap">
                  <div className="check"></div>{' '}
                  <div className="done">{youreDone}</div>
                </div>
              </div>
            )}
            {attributionSelection === 'outsideorg' && (
              <div id="outsideOrganization">
                <hr />
                <div>
                  <strong>
                    {provideCitation}
                    <div className="requiredtool"></div>
                  </strong>
                </div>
                <div>
                  <textarea
                    className="form-control"
                    id="citation"
                    name="citation"
                    placeholder="Type your citation here."
                    onChange={this.handleChangeBound}
                    defaultValue={citation !== 'null' ? citation : ''}
                  />
                  {errorsExist && !citation && (
                    <label
                      id="resourceName-error"
                      className="error-text"
                      htmlFor="resourceName"
                      style={{ display: 'inline-block' }}
                    >
                      {fieldRequired}
                    </label>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    )
  }

  handleDescriptionChange(e) {
    // Hacky way to format the event id and value so parent's edit function works
    // The markdown editor makes this trickier than with a standard textfield
    let event = {
      target: {}
    }
    event.target.id = 'resourceDescription'
    event.target.value = e
    this.handleChange(event)
  }

  handleChangeFormatToUrl() {
    if (
      (this.state.fileName && this.state.fileName.length > 0) ||
      this.state.isUploadingFile
    ) {
      const confirmation = window.confirm(
        'Changing resource type to “Link” will remove your existing resource file. Are you sure you want to continue?'
      )
      if (confirmation) {
        if (this.state.isUploadingFile) {
          // abort request
          this.S3UploaderRef.current.abortRequest('link')
        }
        this.setState((state) => ({
          format: 'url',
          file: '',
          fileName: '',
          attributionSelection: '',
          citation: '',
          fileRemoved: true,
          fileToRemove: state
        }))
      }
    } else {
      this.setState({
        format: 'url',
        file: '',
        fileName: '',
        attributionSelection: '',
        citation: ''
      })
    }
  }

  handleChangeFormatToFile() {
    this.setState({
      format: 'file',
      url: '',
      fileRemoved: true,
      attributionSelection: '',
      startMinutes: null,
      startSeconds: null,
      endMinutes: null,
      endSeconds: null
    })
  }

  async onSaveResourceClick() {
    if (
      !this.state.resourceName ||
      isMissingLinkData(this.state) ||
      isMissingFileData(this.state) ||
      isMissingContentWarnings(this.state)
    ) {
      this.setState({
        errorsExist: true
      })
    } else {
      if (this.state.fileToRemove)
        await this.props.removeResourceFile(this.state.fileToRemove, 'remove')
      if (this.state.fileToPatch)
        await this.props.patchFileUploadInfo(this.state.fileToPatch)
      await this.props.editResource(this.state)
      this.handleHide()
    }
  }

  async onCancelClick() {
    if (this.state.isUploadingFile) {
      const confirmation = window.confirm(
        'Are you sure you want to cancel? All unsaved work will be lost.'
      )
      if (confirmation) {
        await this.S3UploaderRef.current.abortRequest('cancel')
        this.handleHide()
      }
    } else {
      this.handleHide()
    }
  }

  onAttributionClick(e) {
    // for when URL attribution is unchecked
    if (!e.target.checked) {
      this.setState({
        attributionSelection: ''
      })
    } else {
      this.setState({
        attributionSelection: e.target.id
      })
    }
  }

  handleChange(e) {
    this.setState({
      [e.target.id]: e.target.value
    })
  }

  handleHide() {
    this.props.stopEditResource()
  }

  onRemoveFileClick() {
    const confirmation = window.confirm(
      'Are you sure you want to delete this resource file?'
    )
    if (confirmation) {
      this.setState((state) => ({
        file: '',
        fileName: '',
        attributionSelection: '',
        citation: '',
        fileRemoved: true,
        fileToRemove: state
      }))
    }
  }

  onToggleContentWarningsClick(e) {
    const value = JSON.parse(e.target.value)
    this.setState(state => ({
      hasContentWarnings: value,
      content_warnings: {}
    }))
  }

  onSetContentWarningClick(e) {
    const name = e.target.name
    const value = e.target.value
    const checked = e.target.checked

    if (!value) {
      // for the 'none' radios/values
      this.setState(state => ({
        content_warnings: { ...state.content_warnings, [name]: null }
      }))
      // don't love calling risky_behaviors directly here - should be able to handle other potential new values
    } else if (name !== 'risky_behaviors') {
      if (checked) {
        this.setState(state => ({
          content_warnings: {
            ...state.content_warnings,
            [name]: { value: value }
          }
        }))
      } else {
        // Need to handle graphic_content, is only one with a input checkbox for 'none' value
        this.setState(state => ({
          content_warnings: { ...state.content_warnings, [name]: null }
        }))
      }
    } else {
      // for the risky_behaviors - need to handle differently
      checked
        ? this.setState(state => ({
            content_warnings: {
              ...state.content_warnings,
              [name]: state.content_warnings[name]
                ? state.content_warnings[name].concat({ value: value })
                : [{ value: value }]
            }
          }))
        : this.setState(state => ({
            content_warnings: {
              ...state.content_warnings,
              [name]: state.content_warnings[name].filter(
                cw => cw.value !== value
              )
            }
          }))
    }
  }

  onResourceTypeChange(e) {
    this.handleChangeBound(e)
  }

  setPatchFileUploadInfo(file) {
    this.setState(() => ({
      fileToPatch: file,
      fileName: file.original_file_name
    }))
  }

  onUploadFileStart(file) {
    // send resource and file info to parent analytics method
    this.props.onUploadFileStart(this.state, file)
    this.setState(() => ({
      isUploadingFile: true
    }))
  }

  onUploadFileEnd() {
    this.setState(() => ({
      isUploadingFile: false
    }))
  }

  onUploadAbort({ file, source }) {
    this.setState(() => ({
      isUploadingFile: false
    }))
    // send resource, file, and source to parent analytics method
    this.props.onUploadFileAbort(this.state, file, source)
  }

  onUploadComplete({ file, elapsedTime }) {
    this.props.onUploadComplete(this.state, file, elapsedTime)
  }

  onSetYoutubeStartTimeMinutes(minutes) {
    this.setState(() => ({
      startMinutes: minutes
    }))
  }

  onSetYoutubeStartTimeSeconds(seconds) {
    this.setState(() => ({
      startSeconds: seconds
    }))
  }

  onSetYoutubeEndTimeMinutes(minutes) {
    this.setState(() => ({
      endMinutes: minutes
    }))
  }

  onSetYoutubeEndTimeSeconds(seconds) {
    this.setState(() => ({
      endSeconds: seconds
    }))
  }
}

EditResource.propTypes = {
  editResource: PropTypes.func,
  organization: PropTypes.object,
  removeResourceFile: PropTypes.func,
  patchFileUploadInfo: PropTypes.func.isRequired,
  stopEditResource: PropTypes.func.isRequired,
  questId: PropTypes.number.isRequired,
  activityId: PropTypes.number.isRequired,
  resourceId: PropTypes.number.isRequired,
  token: PropTypes.string.isRequired,
  uploadedResourceFile: PropTypes.string,
  onUploadFileStart: PropTypes.func.isRequired,
  onUploadFileAbort: PropTypes.func.isRequired,
  onUploadComplete: PropTypes.func.isRequired
}



// WEBPACK FOOTER //
// ./src/components/activityedit/EditResource.js